module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Attendance-Leaves/Leaves/leave-type-grid/leave-type-grid.component.css
// module id = ./src/app/hrms/Attendance-Leaves/Leaves/leave-type-grid/leave-type-grid.component.css
// module chunks = main